import React, { useEffect, useState } from "react";

import { ThemeProvider } from "@emotion/react";

import { theme } from "./components/base/theme";

import Sitemap from "./components/sitemap";
import FAQPage from "./patient-site/faq-page";
import PatientTestimonialPage from "./components/patient-testimonial-page";
import VideoPage from "./patient-site/video-page";
import HCPResourcesPage from "./hcp-site/hcp-resources-page";

import GenericPage from "./components/generic-page";

import { ContentContext } from "./context/content-context";

import NotFoundPage from "./not-found-page";

// special components for pages that need more specific functionality
const ComponentMapByLocation = {
  "/patient-stories": PatientTestimonialPage,
  "/hcp/testimonials": PatientTestimonialPage,
  "/hcp/resources": HCPResourcesPage,
};

const ComponentMapByTag = {
  "patient-testimonial": VideoPage,
  "video-page": VideoPage,
  "faq-page": FAQPage,
  sitemap: Sitemap,
};

const App = ({
  is404,
  tags,
  rawContent,
  rawSecondaryMenuItems,
  rawPrimaryMenuItems,
  rawSitemapMenuItems,
  rawFooterMenuItems,
  rawVideoPageInfo,
  rawHCPResources,
  rawFaqs,
  rawTestimonials,
  pageTitle,
  hcpCTA,
  patientCTA,
  ...rest
}) => {
  // eslint-disable-next-line no-restricted-globals
  const currentLocation = location.pathname.toLowerCase();
  const isHCP = currentLocation.includes("hcp");

  const Component = is404
    ? NotFoundPage
    : tags?.length > 0
    ? ComponentMapByTag[tags]
    : ComponentMapByLocation[currentLocation] ?? GenericPage;

  const [content, setContent] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getPages = async () => {
      // TODO: how necessary is parsing like this?
      const parsedContent = rawContent
        .split("</section>")
        .map((string) => string + "</section>");

      setContent(parsedContent);
      setIsLoading(false);
    };

    getPages();
  }, [currentLocation, isHCP, rawContent]);

  return (
    <ThemeProvider theme={theme}>
      <ContentContext.Provider
        value={{
          isHCP,
          language: window.location.pathname.includes("/es") ? "esp" : "eng",
          isLoading: is404 ? false : isLoading,
          secondaryMenuItems: JSON.parse(rawSecondaryMenuItems),
          primaryMenuItems: JSON.parse(rawPrimaryMenuItems),
          sitemapMenuItems: JSON.parse(rawSitemapMenuItems),
          footerMenuItems: JSON.parse(rawFooterMenuItems),
          videoPageInfo: JSON.parse(rawVideoPageInfo),
          hcpResources: JSON.parse(rawHCPResources),
          hcpCTA: JSON.parse(hcpCTA),
          patientCTA: JSON.parse(patientCTA),
          pageTitle: is404 ? "404 page not found" : pageTitle,
          faqs: rawFaqs ? JSON.parse(rawFaqs) : null,
          testimonials: rawTestimonials ? JSON.parse(rawTestimonials) : null,
          content,
          ...rest,
        }}
      >
        <Component />
      </ContentContext.Provider>
    </ThemeProvider>
  );
};

export default App;
